import { html, LitElement } from "lit";
import { customElement, property, state } from "lit/decorators.js";
import { unsafeHTML } from "lit/directives/unsafe-html.js";

import { getTeacherNotesData } from "../../data/classroom";
import { events } from "../../utils/events";

import styles from "./teacher-notes.css";

import type { TeacherNoteData } from "../../types.d";
import type { PropertyValues } from "lit";

@customElement("bp-teacher-notes")
export class TeacherNotes extends LitElement {
  static styles = styles;

  @property({ attribute: "arc-id" })
  arcId?: string;

  @state()
  data?: TeacherNoteData;

  handleLinkClick(e: MouseEvent) {
    if (globalThis.window.BibleProjectApp) e.preventDefault();

    events.requestLinkOpen((e.currentTarget as HTMLAnchorElement).href);
  }

  render() {
    if (!this.data) return html`<bp-spinner size="lg"></bp-spinner>`;

    return unsafeHTML(this.data.contentHtml);
  }

  scrollToSlideAnchor(id: string) {
    this.shadowRoot?.querySelector(`[slide-id="${id}"]`)?.scrollIntoView();
  }

  updated(changedProperties: PropertyValues) {
    if (!changedProperties.has("arcId") || !this.arcId) return;

    getTeacherNotesData(this.arcId)
      .then(async ({ data }) => {
        this.data = data;
        this.updateDOMNodes();
      })
      .catch(() => undefined);
  }

  async updateDOMNodes() {
    await this.updateComplete;

    // Ensure all links are treated as "external"
    this.shadowRoot?.querySelectorAll("a").forEach((e) => {
      e.setAttribute("target", "_blank");
      e.removeEventListener("click", this.handleLinkClick);
      e.addEventListener("click", this.handleLinkClick);
    });
  }
}

declare global {
  interface HTMLElementTagNameMap {
    "bp-teacher-notes": TeacherNotes;
  }
}
